import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

import { ToggleComponent } from "./toggle/toggle.component";
import { SalesReportComponent } from "./sales-report/sales-report.component";
import { StatusbarComponent } from "./statusbar/statusbar.component";
import { ProgressStepsComponent } from "./progress-steps/progress-steps.component";
import { CondimentComponent } from "./condiment/condiment.component";
import { CalculatorComponent } from "./calculator/calculator.component";
import { ActionButtonComponent } from "./action-button/action-button.component";
import { ListProductComponent } from "./list-product/list-product.component";
import { GuestProductComponent } from "./guest-product/guest-product.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
  ],
  exports: [CommonModule, FormsModule, SalesReportComponent, ToggleComponent,
    StatusbarComponent, ProgressStepsComponent, CondimentComponent, CalculatorComponent,
    ActionButtonComponent, ListProductComponent, GuestProductComponent, TranslateModule],
  declarations: [ToggleComponent, StatusbarComponent, SalesReportComponent, ProgressStepsComponent, CondimentComponent, CalculatorComponent,
    ListProductComponent, GuestProductComponent, ActionButtonComponent]
})
export class SharedModule {}
